<template>
  <div :class="['collection']">
    <div class="back" @click.stop="goBack">
      <van-icon name="arrow-left"/>
    </div>

    <div class="col_tab">
      <!-- 标签导航栏 -->
      <van-tabs
          v-model="curType"
          class="tabs"
          color="#FF67C1"
          line-height="3px"
          line-width="40px"
          title-active-color="#333333"
          title-inactive-color="#333333"
          @change="switchPage"
      >
        <!-- 文章列表 -->
        <van-tab class="tab1_list" name="0" title="文章">
          <articleItem
              ref="articleItem"
              :fomatterNum="fomatterNum"
              :getCookie="getCookie"
              @isEmpty="isEmpty"
          ></articleItem>
        </van-tab>
        <!-- 帖子列表 -->
        <van-tab class="tab1_list" name="9" title="帖子">
          <invitation
              ref="invitation"
              :fomatterNum="fomatterNum"
              :getCookie="getCookie"
              @isEmpty="isEmpty"
          ></invitation>
        </van-tab>
        <!-- 问答列表 -->
        <van-tab class="tab2_list" name="1" title="问答">
          <expertItem
              ref="expertItem"
              :fomatterNum="fomatterNum"
              :getCookie="getCookie"
              @isEmpty="isEmpty"
          ></expertItem>
        </van-tab>
        <!-- 京城名医 -->
        <van-tab class="tab8_list" name="7" title="课程">
          <beijing-Course ref="course" @isEmpty="isEmpty"></beijing-Course>
        </van-tab>
        <!-- 商品列表 -->
        <van-tab class="tab3_list" name="2" title="商品"></van-tab>
        <!-- 音频列表 -->
        <van-tab class="tab4_list" name="3" title="音频">
          <parentingAudio
              ref="parentingAudio"
              @isEmpty="isEmpty"
          ></parentingAudio>
        </van-tab>
        <!-- 日历列表 -->
        <van-tab class="tab5_list" name="4" title="日历">
          <calendarItem
              ref="calendarItem"
              :fomatterNum="fomatterNum"
              :getCookie="getCookie"
              @enlargeImgOpen="enlargeImgOpen"
              @isEmpty="isEmpty"
          ></calendarItem>
        </van-tab>
        <!-- 儿歌列表 -->
        <van-tab class="tab6_list" name="5" title="儿歌">
          <childSongs
              ref="childSongs"
              :isVideoState="isVideoState"
              @audioChildEvent="handleAudio"
              @isEmpty="isEmpty"
          ></childSongs>
        </van-tab>
        <!-- 辅食列表 -->
        <van-tab class="tab7_list" name="6" title="辅食">
          <babyFeed ref="sideDish" @isEmpty="isEmpty"></babyFeed>
          <!--          <sideDish ref='sideDish' @isEmpty='isEmpty'></sideDish>-->
        </van-tab>
      </van-tabs>
      <div class="openWrap">
        <openWxTag
            id="xmyxItem1"
            btnStyle="width:79px;height:44px"
            path="/subPackages/xmhMainProcess/collection/index"
        ></openWxTag>
      </div>
      <empty-list v-if="emptyList"></empty-list>
    </div>
    <audioShare ref="share"></audioShare>
    <!-- 日历放大弹窗 -->
    <calenImg
        v-show="enlargeImgShow"
        :enlargeImgItem="enlargeImgItem"
        :type="'collect'"
        @deleteItem="deleteItem"
        @enlargeImg="enlargeImg"
    ></calenImg>
  </div>
</template>

<script>
import {fomatterNum, getCookie, wx_launch} from '@/assets/js/common.js'
// 数据为空组件
import emptyList from '@/components/contents/emptyList.vue'
// 文章组件
import articleItem from '@/components/member/collect/article.vue'
//帖子组价
import invitation from '@/components/member/collect/invitation.vue'
// 问答组件
import expertItem from '@/components/member/collect/expert.vue'
//音频组件
import parentingAudio from '@/components/member/collect/parentingAudio_1.0.vue'
// 日历组件
import calendarItem from '@/components/member/collect/calendar.vue'
// 儿歌组件
import childSongs from '@/components/member/collect/childSongs.vue'
// 辅食组件
// import sideDish from "@/components/member/collect/sideDish.vue";
import babyFeed from '@/components/member/collect/babyFeed.vue'
// 京城名医组件
import beijingCourse from '@/components/member/collect/beijingDoctorCourseNew.vue'

//分享弹窗
import audioShare from '@/components/comment/share.vue'

// 育儿日历图片放大
import calenImg from '@/components/contents/calendar/calenImg.vue'
import openWxTag from '@/components/common/openWeappTag/index.vue' // 打开小程序开放标签
import {setTimeout} from 'timers'

export default {
  name: 'collection',
  components: {
    emptyList,
    articleItem,
    expertItem,
    parentingAudio,
    calendarItem,
    childSongs,
    calenImg,
    audioShare,
    babyFeed,
    beijingCourse,
    openWxTag,
    invitation,
  },
  data() {
    return {
      curType: '0', // 标签索引
      switchTagId: parseInt(this.$route.query.tagId) || 0,
      emptyList: false, // 没有内容
      userInfo: [], // 用户信息
      isLogin: true,
      isEdit: false,
      enlargeImgItem: null, // 当前要放大日历的数据对象
      enlargeImgShow: false,
      isVideoState: false, // 视频跳转时 是否暂停播放
      appId:
          this.$http.hostName === 'https://mom.feihe.com'
              ? 'gh_fe3214457b8e'
              : 'gh_0b629d0f8f67', // 小程序appid
    }
  },

  mounted() {
    var shareDataParams = {
      shareLink: this.$http.hostName + '/home',
      shareDesc: '1000万中国家庭都在看！科学育儿，全程陪伴，源于母爱。',
      shareTitle: '星妈会',
      imgUrl: 'https://image-mom.feihe.com/wxshare/home.png', //必须是绝对路径
    }
    this.wxJsSet.wxShare('fx', shareDataParams, this)
    // this.getAudio(); //获取音频
    if (this.userInfo.second_baby_birthday) {
      //是否存在宝宝生日
      this.isEdit = true
    }
    setTimeout(() => {
      const open = document.getElementsByClassName('openWrap')[0]
      const tab = document.getElementsByClassName('van-tab')[4]
      tab.appendChild(open)
    }, 200)
  },

  beforeRouteLeave(to, from, next) {
    if (to.name !== 'audiodetail' && to.name != 'parentchildsongsdetail') {
      this.$store.commit('removeIncludes')
    }
    if (to.name == 'profile') {
      sessionStorage.removeItem('switchTagId')
    }
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.curType = sessionStorage.getItem('switchTagId')
      vm.$store.commit('changeIncludes', [to.name, 'profile'])
    })
  },
  created() {
    const oScript = document.createElement('script')
    oScript.type = 'text/javascript'
    oScript.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js'
    document.body.appendChild(oScript)
  },
  methods: {
    // sucFun:function (){
    //   console.log('11111111111111')
    //   this.initToMini()
    //   const box = document.getElementById('xmyxItem2')
    //   console.log(box.click())
    // },
    toJSON() {
    },
    //跳转小程序初始化
    initToMini() {
      // 自定义html内容
      let content = `
        <span class="text" style="font-size:12px;color:#666;opacity:0;display:block;width:79px;height:44px">星妈优选</span>
        `
      let launchParams = {
        eleId: 'xmyxItem2', // 元素id
        appid: this.appId,
        url: 'pages/index/index.html', // 跳转小程序的页面路径
        content: content, // 自定义的html内容
      }
      this.wx_launch(launchParams)
    },
    wx_launch,
    fomatterNum, //格式化数字
    getCookie,
    // 切换标签
    switchPage: function (name, title) {
      if (this.switchTagId == name) return false
      if (this.$refs.parentingAudio) {
        if (this.$refs.parentingAudio.audioList.length > 0) {
          this.$refs.parentingAudio.cancelPlay()
        }
      }
      sessionStorage.setItem('switchTagId', name)
      this.switchTagId = name
      this.curType = name
      this.emptyList = false
      const _this = this

      this.isVideoState = false //离开时暂停视频播放
      this.isAudio = false

      this.$nextTick(() => {
        switch (name) {
          case '0':
            _this.$refs.articleItem.initFn()
            gio('track', 'collectionCount', {position_var: '文章'})
            break
          case '9':
            _this.$refs.invitation.initFn()
            gio('track', 'collectionCount', {position_var: '帖子'})
            break
          case '1':
            _this.$refs.expertItem.initFn()
            gio('track', 'collectionCount', {position_var: '问答'})
            break
          case '2':
            gio('track', 'collectionCount', {position_var: '商品'})
            setTimeout(function () {
              // location.href = _this.$http.extStarMomHostName + 'api/wechat/auth/assets?page=collectionList&xmhSource=scjShop';
            }, 200)
            break
          case '3':
            _this.$refs.parentingAudio.initFn()
            break
          case '4':
            _this.$refs.calendarItem.initFn()
            break
          case '5':
            _this.isVideoState = true
            _this.$refs.childSongs.initFn()
            break
          case '6':
            _this.$refs.sideDish.initFn()
            break
          case '7':
            _this.$refs.course.initFn()
            break
        }
      })
    },
    // 放大日历弹窗关闭
    enlargeImg(flag) {
      this.enlargeImgShow = flag
    },
    // 日历取消收藏
    deleteItem(flag, item) {
      this.$refs.calendarItem.collectChange(flag, item)
    },
    enlargeImgOpen(flag, data) {
      this.enlargeImgShow = flag
      this.enlargeImgItem = data
    },
    // 数据为空时音频不显示
    isAudioShow(flag) {
      this.isAudio = flag
    },
    //育儿音频列表组件回调
    handleAudio(toastShare, data, playState) {
      console.log(data)
      this.audioParams = data
      this.isPlayAudio = playState
      if (toastShare) {
        this.$refs.share.showShareVideo()
      }
    },
    // 列表数据为空显示
    isEmpty(flag) {
      console.log(flag, '-------')
      this.emptyList = flag
    },
    // 返回上一页面
    goBack: function () {
      if (window.history.length > 1 && this.getCookie('fromPath')) {
        this.$router.go(-1)
      } else {
        this.$router.push('/mine')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.nomal {
  background: #f2f2f2 !important;
}

.back {
  background: #fff !important;
}

.openWrap {
  width: 79px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;

  #xmyxItem1 {
    position: absolute;
    width: 79px;
    height: 45px;
  }
}

.collection {
  min-height: 100vh;
  background: #fff;

  .col_tab {
    // 导航栏
    /deep/ .van-tabs {
      .van-tabs__nav {
        padding-left: 20px;
      }

      .van-tabs__content {
        padding-top: 40px;
      }

      .van-tabs__wrap {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
      }

      .van-tabs__track {
        margin-top: 44px;
      }

      .van-tab {
        width: 79px;
      }

      .tab4_list {
        background-color: #f2f2f2;

        .van-list__finished-text {
          background-color: #f2f2f2;
        }
      }

      .tab5_list {
        background-color: #f2f2f2;

        .van-list__finished-text {
          background-color: #fff;
        }
      }

      .tab3_list {
        display: block !important;
      }
    }
  }

  /deep/ .tab6_list {
    background: #f2f2f2;
  }

  .back {
    font-size: @indexFontSize20;
    z-index: 10;
    position: fixed;
    width: 44px;
    z-index: 10;
    height: 44px;
    background: #fff;

    .van-icon {
      display: inline-block;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
